"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _warning = _interopRequireDefault(require("warning"));
var _filterProps = _interopRequireDefault(require("../helpers/filterProps"));
var _styled = _interopRequireWildcard(require("../styled"));
var _icons = _interopRequireWildcard(require("./icons"));
var _excluded = ["type", "children"];
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getIcon = function getIcon(type) {
  return _icons.default[type in _icons.alias ? _icons.alias[type] : type];
};
var getColor = function getColor(propName, fallback) {
  return function (props) {
    var propValue = props[propName];
    if (propValue != null) {
      if (typeof propValue === 'function') {
        // call & return function with props
        return propValue(props);
      }

      // pass color to prop helper with same value as fallback
      return (0, _styled.prop)(propValue, propValue)(props);
    }

    // else return default value
    return fallback;
  };
};
var getWidth = function getWidth(props) {
  if (props.width != null) {
    return typeof props.width === 'number' ? (0, _styled.rem)(props.width) : props.width;
  } else if (props.height != null) {
    return 'auto';
  }
  return '1em';
};
var getHeight = function getHeight(props) {
  if (props.height != null) {
    return typeof props.height === 'number' ? (0, _styled.rem)(props.height) : props.height;
  } else if (props.width != null) {
    return 'auto';
  }
  return '1em';
};
var filteredProps = ['padding', 'hasChildren', 'width', 'height', 'fill', 'stroke', 'color'];
var Span = function Span(props) {
  return /*#__PURE__*/_react.default.createElement("span", (0, _filterProps.default)(props, filteredProps));
};
var IconSpan = (0, _styled.default)(Span)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: ", ";\n\n  > svg {\n    display: inline-block;\n    color: ", ";\n    margin-right: ", ";\n    margin-top: ", ";\n    width: ", ";\n    height: ", ";\n\n    * {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n"])), (0, _styled.prop)('theme.icons.padding'), getColor('color', 'inherit'), (0, _styled.ifProp)('hasChildren', (0, _styled.prop)('theme.icons.textMargin')), (0, _styled.ifProp)('hasChildren', '-0.1em'), getWidth, getHeight, getColor('fill'), getColor('stroke'));
// TODO: add width and height props
var Icon = function Icon(_ref) {
  var type = _ref.type,
    children = _ref.children,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var icon = getIcon(type);
  var hasChildren = children != null;
  (0, _warning.default)(icon != null, "[Icon] Invalid icon type '" + type + "'");
  return /*#__PURE__*/_react.default.createElement(IconSpan, Object.assign({
    hasChildren: hasChildren
  }, props), icon != null ? /*#__PURE__*/(0, _react.createElement)(icon) : undefined, children);
};
Icon.defaultProps = {
  children: null,
  width: null,
  height: null,
  color: null
};
var _default = exports.default = Icon;